import React, { useState, useEffect } from 'react';
import { mealService } from '../../../services/mealService';
import Icon from '../../../components/AppIcon';

const TodaysGalleyPlanCard = ({ trip }) => {
  const [todaysMeals, setTodaysMeals] = useState({
    breakfast: null,
    lunch: null,
    dinner: null
  });
  const [currentDay, setCurrentDay] = useState(1);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadTodaysMeals();
  }, [trip]);

  const loadTodaysMeals = async () => {
    if (!trip?.id || !trip?.startDate) {
      setLoading(false);
      return;
    }

    setLoading(true);

    // Calculate current day of trip
    const startDate = new Date(trip.startDate);
    const today = new Date();
    const diffTime = today - startDate;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    const dayNumber = Math.max(1, Math.min(diffDays + 1, trip?.duration || 1));

    setCurrentDay(dayNumber);

    // Fetch all meals for the trip
    const { data: meals } = await mealService?.getMealsByTrip(trip?.id);

    if (meals && meals?.length > 0) {
      // Filter meals for current day that are selected
      const dayMeals = meals?.filter((m) => m?.dayNumber === dayNumber && m?.isSelected === true);

      setTodaysMeals({
        breakfast: dayMeals?.find((m) => m?.type === 'Breakfast') || null,
        lunch: dayMeals?.find((m) => m?.type === 'Main Meal') || null,
        dinner: dayMeals?.find((m) => m?.type === 'Secondary Meal') || null
      });
    }

    setLoading(false);
  };

  const renderMeal = (mealType, meal) => {
    if (!meal) {
      return (
        <div className="text-xs text-muted-foreground italic">no meal selected
                  </div>);

    }

    return (
      <div className="flex items-start gap-2">
        <Icon
          name={mealType === 'Breakfast' ? 'coffee' : mealType === 'Lunch' ? 'utensils' : 'utensils'}
          className="w-3 h-3 text-primary mt-0.5 flex-shrink-0" />

        <div className="flex-1 min-w-0">
          <p className="text-xs md:text-sm font-medium text-foreground truncate">
            {meal?.name}
          </p>
          {meal?.isLeftover &&
          <span className="text-xs text-muted-foreground italic">Leftovers</span>
          }
        </div>
      </div>);

  };

  if (loading) {
    return (
      <div className="flex flex-col">
        <span className="text-xs md:text-sm text-muted-foreground mb-2">Today's Galley Plan</span>
        <div className="bg-muted/30 rounded-lg p-3 md:p-4">
          <p className="text-xs text-muted-foreground">Loading...</p>
        </div>
      </div>);

  }

  return;






















};

export default TodaysGalleyPlanCard;